import { OnInit, ElementRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/';
import { Subject } from 'rxjs';
import { ThemeSettingService } from '../services/theme-setting.service';
import { WorkspaceService } from '../services/workspace.service';
var DetailPopupComponent = /** @class */ (function () {
    function DetailPopupComponent(bsModalRef, themeSettingService, workspaceService) {
        this.bsModalRef = bsModalRef;
        this.themeSettingService = themeSettingService;
        this.workspaceService = workspaceService;
        this.refresh = false;
        this.isBusy = false;
        this.actions = [];
    }
    DetailPopupComponent.prototype.handleKeyup = function (event) {
        if (event.keyCode === 8 && event.target.tagName.toUpperCase() != "INPUT" && event.target.tagName.toUpperCase() != "TEXTAREA") {
            event.preventDefault();
        }
    };
    DetailPopupComponent.prototype.ngOnInit = function () {
        this.refreshDetail = new Subject();
        this.loaderConfig = this.themeSettingService.getTheme();
    };
    DetailPopupComponent.prototype.hide = function () {
        this.bsModalRef.hide();
    };
    DetailPopupComponent.prototype.closeCard = function () {
        this.workspaceService.closeCard(this.componentId).subscribe(function (result) {
            //console.log(result);
            // if result == 1 ok
        });
        this.bsModalRef.hide();
    };
    DetailPopupComponent.prototype.setTitle = function ($event) {
        this.popTitle = $event;
    };
    DetailPopupComponent.prototype.handleLoading = function ($event) {
        this.height = this.modalBody.nativeElement.offsetHeight;
        this.isBusy = $event;
    };
    DetailPopupComponent.prototype.setActions = function (actions) {
        this.actions = actions;
    };
    DetailPopupComponent.prototype.setCurrentAction = function (action) {
        var _this = this;
        if (this.currentAction) {
            if (this.currentAction.ActionName == action.ActionName) {
                this.currentAction = null;
                setTimeout(function () {
                    _this.currentAction = action;
                });
            }
            else {
                this.currentAction = action;
            }
        }
        else {
            this.currentAction = action;
        }
    };
    return DetailPopupComponent;
}());
export { DetailPopupComponent };
